import React, { useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { XLg } from 'react-bootstrap-icons'
import './style.scss'

export default () => {
  const [show, setShow] = useState(false)

  React.useEffect(() => {
    document.addEventListener('updateAvailable', handleShow)
  }, [])

  const handleClose = () => {
    setShow(false)
  }

  const handleRefresh = async () => {
    window.location.reload()
  }

  const handleShow = () => {
    setShow(true)
  }

  return (
    <CSSTransition in={show} timeout={200} classNames="slide-up" unmountOnExit>
      <div className="update-widget bg-warning">
        <div className="row p-3 ">
          <div className="d-flex col-2 align-items-center">
            <button className="btn btn-sm" onClick={handleClose}>
              <XLg size="16" />
            </button>
          </div>
          <div className="d-flex col-6 col-sm-8 align-items-center">
            <div className="align-self-center">
              OtoCo Dapp update available. Refresh this tab to fetch last
              updates.
            </div>
          </div>
          <div className="d-flex col-4 col-sm-2 align-items-center">
            <button
              className="btn btn-sm btn-outline-light"
              onClick={handleRefresh}
            >
              refresh
            </button>
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}
